import one from "./Cups01.jpg";
import two from "./Cups02.jpg";
import three from "./Cups03.jpg";
import four from "./Cups04.jpg";
import five from "./Cups05.jpg";
import six from "./Cups06.jpg";
import seven from "./Cups07.jpg";
import eight from "./Cups08.jpg";
import nine from "./Cups09.jpg";
import ten from "./Cups10.jpg";
import page from "./Cups11.jpg";
import knight from "./Cups12.jpg";
import queen from "./Cups13.jpg";
import king from "./Cups14.jpg";

const cups = [
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  page,
  knight,
  queen,
  king,
];

export default cups;
